// Types
export interface SpeechToken {
  token: string;
  region: string;
  expires_at: string;
}

export interface SupportedLanguage {
  code: string;
  name: string;
  native: string;
}

export interface SpeechServiceStatus {
  enabled: boolean;
  region: string;
  connected: boolean;
  message?: string;
}

const API_BASE = '/api/v1/speech';

// Helper function for authenticated requests
async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem('auth_token');
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response;
}

// API functions
export const speechService = {
  /**
   * Get an authorization token for the Azure Speech SDK
   * Token is valid for 10 minutes
   */
  async getToken(): Promise<SpeechToken> {
    const response = await fetchWithAuth(`${API_BASE}/token`);
    return response.json();
  },

  /**
   * Get the list of supported languages for speech recognition
   */
  async getLanguages(): Promise<SupportedLanguage[]> {
    const response = await fetchWithAuth(`${API_BASE}/languages`);
    return response.json();
  },

  /**
   * Get the current status of the Azure Speech service
   */
  async getStatus(): Promise<SpeechServiceStatus> {
    const response = await fetchWithAuth(`${API_BASE}/status`);
    return response.json();
  },
};

export default speechService;
